/**
 * POS-to-kiosk handoff token capture.
 * The QR code encodes a URL like /handoff?tok=<token>.
 * This module extracts and validates the token shape before calling the API.
 */

export function extractHandoffToken(search: string): string | null {
  const params = new URLSearchParams(search);
  const tok = params.get("tok");
  if (!tok || tok.length < 20) return null;
  return tok;
}
